// TODO: move to app-types or global-types

export enum SeatingType {
  'In Lap' = 'IN_LAP',
  'In Seat' = 'IN_SEAT',
  'IN_SEAT' = 'In Seat',
  'IN_LAP' = 'In Lap',
}

export interface TravelersFilterValue {
  filter: {
    adults?: string;
    children?: string;
    rooms?: string;
  };
  age: Record<number, number>;
  seating: Record<number, SeatingType>;
}

export const travlersDefaultValue: Readonly<TravelersFilterValue> = {
  filter: {
    adults: '1 Adult',
    children: 'Add',
    rooms: '1 Room',
  },
  age: {},
  seating: {},
};
